import { c as _c } from "react/compiler-runtime";
import useChatPanelStore from '@module/stores/useChatPanelStore';
import { BaseRightArrow } from '@module/svg/icons';
interface Props {
  behavior: 'open' | 'close';
}
function ChatPanelButton(t0) {
  const $ = _c(11);
  const {
    behavior
  } = t0;
  const {
    openChatPanel,
    closeChatPanel
  } = useChatPanelStore(_temp);
  const id = behavior === "open" ? "open-chat-panel" : "close-chat-panel";
  let t1;
  if ($[0] !== behavior || $[1] !== closeChatPanel || $[2] !== openChatPanel) {
    t1 = e => {
      e.stopPropagation();
      if (behavior === "open") {
        openChatPanel();
      } else {
        closeChatPanel();
      }
    };
    $[0] = behavior;
    $[1] = closeChatPanel;
    $[2] = openChatPanel;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = behavior === "open" ? "scale(-1, 1)" : undefined;
  let t3;
  if ($[4] !== t2) {
    t3 = <BaseRightArrow style={{
      fontSize: 6,
      color: "var(--colorIco09)",
      transform: t2
    }} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== behavior || $[7] !== id || $[8] !== t1 || $[9] !== t3) {
    t4 = <button id={id} data-gtm-chat-panel={behavior} type="button" className="flex h-[42px] w-[42px] items-center justify-center rounded-l-[8px] border-borderBg01 border-y border-l bg-baseBg hover:bg-colorBg01" aria-label={"\uCC44\uD305 \uC811\uAE30"} onClick={t1}>{t3}</button>;
    $[6] = behavior;
    $[7] = id;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(s) {
  return {
    openChatPanel: s.openChatPanel,
    closeChatPanel: s.closeChatPanel
  };
}
export default ChatPanelButton;